<template>
  <q-page class="items-center pragma-black">
    <q-pull-to-refresh @refresh="refresh" color="blue-grey">
      <q-card style="width: 100%" flat square class="pragma-black">
        <q-card-section
          class="q-pa-sm text-center"
          :style="`background-color: #${bar_color}`"
        >
          <div class="row">
            <div class="col-xs-2">
              <q-btn
                color="white"
                icon="search"
                flat
                @click="search = !search"
              ></q-btn>
            </div>
            <div class="col-xs-8">
              <span class="text-h6 text-white"><strong>{{section.title}}</strong></span>
            </div>
            <div class="col-xs-2 text-right q-pa-none">
              <q-btn
                icon="monetization_on"
                flat
                color="white"
              >
                <q-menu class="bg-white custom-font">
                  <q-list style="min-width: 200px" dark separator dense>
                    <q-item
                      clickable
                      v-close-popup
                      v-for="total_moneda in total_monedas"
                      :key="total_moneda.title"
                    >
                      <div class="row full-width flex flex-center text-bold" :style="`color: ${total_moneda.color}`">
                        <div class="col-xs-6">
                          {{total_moneda.title}}
                        </div>
                        <div class="col-xs-6 text-right">
                          {{util.numberMoney(total_moneda.amount)}}
                        </div>
                      </div>
                    </q-item>
                  </q-list>
                </q-menu>
              </q-btn>
            </div>
          </div>
        </q-card-section>
        <q-separator></q-separator>
          <!-- <Filter v-if="search" @close-search-screen="closeSearchScreen"/> -->
        <q-card-section class="text-white q-pa-none" v-if="search">
          <div class="row">
            <div class="col-xs-12 q-pa-sm">
              <q-select
                v-model="search_params.empresa_id"
                :options="empresas"
                label="Empresa"
                option-label="nombre"
                option-value="id"
                emit-value
                map-options
                outlined
                dense
                label-color="grey"
                dark
                @update:model-value="getProyectosEmpresa()"
              ></q-select>
            </div>
            <div class="col-xs-12 q-pa-sm">
              <q-select
                v-model="search_params.proyecto_id"
                :options="proyectos"
                label="Proyecto"
                option-label="nombre"
                option-value="id"
                emit-value
                map-options
                outlined
                dense
                label-color="grey"
                dark
                :disable="proyectos.length <= 1"
              ></q-select>
            </div>
            <div class="col-xs-12 q-pa-sm">
              <q-select
                v-model="search_params.gestion_id"
                :options="gestiones"
                label="Gestión"
                option-label="gestion"
                option-value="id"
                emit-value
                map-options
                outlined
                dense
                label-color="grey"
                dark
              ></q-select>
            </div>
            <div class="col-xs-12 q-pa-sm">
              <strong>Monto</strong>
            </div>
            <div class="col-xs-4 q-pa-sm">
              <q-select
                v-model="search_params.selectMonto"
                :options="select_monto"
                option-label="tipo"
                option-value="id"
                emit-value
                map-options
                outlined
                dense
                label-color="grey"
                dark
              ></q-select>
            </div>
            <div class="col-xs-8 q-pa-sm">
              <q-input
                v-model="search_params.monto"
                type="number"
                class="iu"
                outlined
                dense
                label-color="grey"
                dark
              ></q-input>
            </div>
            <div class="col-xs-6 q-pa-sm">
              <q-input
                v-model="search_params.fecha_ini"
                label="Desde"
                readonly
                dense
                label-color="grey"
                outlined
                dark>
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy ref="qDateProxy" cover transition-show="scale" transition-hide="scale">
                      <q-date v-model="search_params.fecha_ini" color="blue-grey" mask="DD/MM/YYYY" dark>
                        <div class="row items-center justify-end">
                          <q-btn v-close-popup label="Aceptar" color="white" flat />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-xs-6 q-pa-sm">
              <q-input
                v-model="search_params.fecha_fin"
                label="Hasta"
                readonly
                dense
                label-color="grey"
                outlined
                dark
              >
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy ref="qDateProxy" cover transition-show="scale" transition-hide="scale">
                      <q-date v-model="search_params.fecha_fin" color="blue-grey" mask="DD/MM/YYYY" dark>
                        <div class="row items-center justify-end">
                          <q-btn v-close-popup label="Aceptar" color="primary" flat />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-xs-12 q-pa-sm">
              <q-select
                v-model="search_params.campo"
                :options="campos"
                label="Columna"
                option-label="nombre"
                option-value="id"
                emit-value
                map-options
                outlined
                dense
                label-color="grey"
                dark
              ></q-select>
            </div>
            <div class="col-xs-12 q-pa-sm">
              <q-input
                v-model="search_params.texto"
                label="Texto a buscar de la columna"
                class="iu"
                outlined
                dense
                label-color="grey"
                dark
                v-if="search_params.campo !== 0"
              ></q-input>
            </div>
            <div class="col-xs-12 q-pa-sm text-center">
              <q-btn
                color="teal"
                label="Filtrar"
                :loading="loading_filter"
                class="full-width"
                @click="filter(); has_filter = true"
              ></q-btn>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 text-center" @click="search = false">
              <q-icon name="expand_less" size="lg"></q-icon>
            </div>
          </div>
        </q-card-section>
        <q-separator class="bg-white" v-if="search"></q-separator>
        <q-card-section class="text-white" v-if="params_filter !== '' && has_filter">
          <p class="text-bold">FILTROS:</p>
          <span>{{params_filter}}</span>
        </q-card-section>
        <q-separator class="bg-white" v-if="params_filter !== '' && has_filter"></q-separator>
        <q-card-section class="q-pa-none text-white">
          <q-checkbox
            v-model="search_params.chk_fr_cc"
            color="secondary"
            label="Ver solo fondos rotativos, cajas chicas y reposiciones"
            true-value="view_fr_cc"
            false-value=""
            dark
            @update:model-value="filter"
          />
        </q-card-section>
        <q-card-section class="text-center" v-if="solicitudes.length ==  0 && !loading">
          <span class="text-blue-grey"><q-icon name="sentiment_very_dissatisfied"></q-icon> No tiene solicitudes en esta sección</span>
        </q-card-section>
        <q-card-section class="q-pa-none">
          
          <div class="row full-width">
            <div class="col-xs-12">
              <q-infinite-scroll @load="onLoad" :offset="250" v-if="solicitudes.length > 0" ref="infiniteScroll">
                <q-list bordered separator dark v-if="!(current_page.includes('solicitudes-admin/tesoreria') || current_page.includes('solicitudes-admin/rechazadas') || current_page.includes('solicitudes-admin/rechazadas-tesoreria') || current_page.includes('solicitudes-admin/todas'))">
                  <q-slide-item
                    @left="opt => onLeft(solicitud, opt)"
                    @right="opt => onRight(solicitud, opt)"
                    v-for="solicitud in solicitudes"
                    :key="solicitud.id"
                    class="pragma-black"
                    dark
                  >
                    <template v-slot:left>
                      <q-icon name="done" />
                    </template>

                    <template v-slot:right v-if="current_page.includes('solicitudes-admin/pendientes') || current_page.includes('solicitudes-admin/creadas') || current_page.includes('solicitudes-admin/autorizadas') || current_page.includes('solicitudes/admin')">
                      <q-icon name="keyboard_tab" />
                    </template>

                    <q-item
                      clickable
                      v-ripple
                      @click="verDetalle(solicitud.id)"
                    >
                      <q-item-section avatar>
                        <q-badge
                          :class="current_page.includes('solicitudes-disponibles') ? `text-body1 bg-teal` : `text-body1 ${getColorCard(solicitud.created_at)}`" 
                          style="min-width: 50px"
                        >
                          <div class="row items-center text-center full-width">
                            <div class="col-xs-12">
                              {{solicitud.numero}}
                            </div>
                          </div>
                        </q-badge>
                        <q-tooltip class="bg-blue-grey text-body2" :offset="[10, 10]">
                          {{solicitud.nom_completo_proyecto}}
                        </q-tooltip>
                      </q-item-section>
                      <q-item-section>
                        <!-- <q-item-label>{{solicitud.proyecto.nombre}}</q-item-label> -->
                        <q-item-label>{{solicitud.proyecto.empresa.nombre}}</q-item-label>
                        <q-item-label caption class="text-blue-grey">
                          <strong>{{solicitud.proyecto.nombre}}</strong><br>
                          {{solicitud.modalidad.nombre}}
                        </q-item-label>
                      </q-item-section>

                      <q-item-section side top>
                        <q-badge color="blue-grey" style="min-width: 50px">
                          <div class="row items-center text-center full-width">
                            <div class="col-xs-12">
                              {{solicitud.estadoCodigo}}
                            </div>
                          </div>
                        </q-badge>
                        <q-item-label class="text-right text-caption q-pt-md text-bold text-white"><span :class="getColorMoney(solicitud.moneda)">{{`${solicitud.moneda.sigla} ${util.numberMoney(solicitud.total)}`}}</span></q-item-label>
                      </q-item-section>
                    </q-item>
                  </q-slide-item>
                </q-list>

                <q-list bordered separator dark v-if="current_page.includes('solicitudes-admin/tesoreria') || current_page.includes('solicitudes-admin/rechazadas') || current_page.includes('solicitudes-admin/rechazadas-tesoreria') || current_page.includes('solicitudes-admin/todas')">
                  <q-item
                    clickable
                    v-ripple
                    @click="verDetalle(solicitud.id)"
                    v-for="solicitud in solicitudes"
                    :key="solicitud.id"
                  >
                    <q-item-section avatar>
                      <q-badge
                        :class="current_page.includes('solicitudes-disponibles') ? `text-body1 bg-teal` : `text-body1 ${getColorCard(solicitud.created_at)}`" 
                        style="min-width: 50px"
                      >
                        <div class="row items-center text-center full-width">
                          <div class="col-xs-12">
                            {{solicitud.numero}}
                          </div>
                        </div>
                      </q-badge>
                      <q-tooltip class="bg-blue-grey text-body2" :offset="[10, 10]">
                        {{solicitud.nom_completo_proyecto}}
                      </q-tooltip>
                    </q-item-section>
                    <q-item-section>
                      <!-- <q-item-label>{{solicitud.proyecto.nombre}}</q-item-label> -->
                      <q-item-label>{{solicitud.proyecto.empresa.nombre}}</q-item-label>
                      <q-item-label caption class="text-blue-grey">
                        <strong>{{solicitud.proyecto.nombre}}</strong><br>
                        {{solicitud.modalidad.nombre}}
                      </q-item-label>
                    </q-item-section>

                    <q-item-section side top>
                      <q-badge color="blue-grey" style="min-width: 50px">
                        <div class="row items-center text-center full-width">
                          <div class="col-xs-12">
                            {{solicitud.estadoCodigo}}
                          </div>
                        </div>
                      </q-badge>
                      <q-item-label class="text-right text-caption q-pt-md text-bold text-white"><span :class="getColorMoney(solicitud.moneda)">{{`${solicitud.moneda.sigla} ${util.numberMoney(solicitud.total)}`}}</span></q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
                <template v-slot:loading>
                  <div class="row justify-center q-my-md">
                    <q-spinner-bars color="blue-grey" size="40px" />
                  </div>
                </template>
              </q-infinite-scroll>
            </div>
          </div>
          
        </q-card-section>
      </q-card>
    </q-pull-to-refresh>

    <!-- Floating Button -->
    <!-- <q-page-sticky position="bottom-right" :offset="[18, 18]">
      <q-fab
        v-model="fabRight"
        vertical-actions-align="right"
        class="bg-pragma"
        icon="keyboard_arrow_up"
        direction="up"
        text-color="white"
      >
        <q-fab-action label-position="left" class="bg-pragma" text-color="white" @click="() => router.push({name: 'searchAprobar'})" icon="search" label="Buscar solicitud" />
        <q-fab-action v-if="created" label-position="left" class="bg-pragma" text-color="white" @click="crearSolicitud()" icon="add" label="Nueva solicitud" />
      </q-fab>
    </q-page-sticky> -->

    <!-- Confirmación de aprobación Express -->
    <q-dialog
      v-model="express.dialog"
      persistent
      class="custom-font text-uppercase"
    >
      <q-card class="full-width pragma-black text-white">
        <q-form @submit.prevent="aprobarExpress()">
          <q-card-section class="q-pa-none text-white">
            <q-toolbar
              class="bg-pragma"
            >
              <span class="text-bold">APROBACIÓN EXPRESS</span>
              <q-space></q-space>
              <q-btn
                icon="clear"
                flat
                @click="express.dialog = false"
              ></q-btn>
            </q-toolbar>
          </q-card-section>
          <q-card-section>
            <div class="row q-gutter-y-sm">
              <div class="col-xs-12 text-center">
                ¿Está seguro/a que desea aprobar la solicitud?
              </div>
              <div class="col-xs-6 text-white q-pr-xs">
                <q-card flat class="bg-pragma">
                  <q-card-section class="text-caption q-pa-xs text-bold">
                    Nro de solicitud
                  </q-card-section>
                  <q-card-section class="q-pa-xs">
                    {{express.solicitud.numero}}
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-xs-6 text-white q-pl-xs">
                <q-card flat class="bg-grey-9">
                  <q-card-section class="text-caption q-pa-xs text-bold">
                    Monto ({{express.solicitud.moneda.nombre}})
                  </q-card-section>
                  <q-card-section class="q-pa-xs">
                    {{util.numberMoney(express.solicitud.total)}}
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-xs-12 text-white">
                <q-card flat class="bg-grey-9">
                  <q-card-section class="text-caption q-pa-xs text-bold">
                    Proyecto
                  </q-card-section>
                  <q-card-section class="q-pa-xs">
                    {{express.solicitud.nom_completo_proyecto}}
                  </q-card-section>
                </q-card>
              </div>
            </div>
            
          </q-card-section>
          <q-card-actions>
            <div class="row full-width">
              <div class="col-xs-6 q-pa-sm">
                <q-btn
                  label="Cancelar"
                  color="negative"
                  icon="clear"
                  class="full-width"
                  @click="express.dialog = false"
                ></q-btn>
              </div>
              <div class="col-xs-6 q-pa-sm">
                <q-btn
                  type="submit"
                  label="Aprobar"
                  color="positive"
                  icon="check"
                  class="full-width"
                  :loading="express.loading"
                ></q-btn>
              </div>
            </div>
          </q-card-actions>
        </q-form>
      </q-card>
    </q-dialog>

    <!-- Movimiento de pendiente -->
    <q-dialog
      v-model="move_pendiente.dialog"
      persistent
      class="custom-font text-uppercase"
    >
      <q-card class="full-width pragma-black text-white">
        <q-form @submit.prevent="moverPendiente()">
          <q-card-section class="q-pa-none text-white">
            <q-toolbar
              class="bg-pragma"
            >
              <span class="text-bold">Mover pendiente</span>
              <q-space></q-space>
              <q-btn
                icon="clear"
                flat
                @click="move_pendiente.dialog = false"
              ></q-btn>
            </q-toolbar>
          </q-card-section>
          <q-card-section>
            <div class="row q-gutter-y-sm">
              <div class="col-xs-6 text-white q-pr-xs">
                <q-card flat class="bg-pragma">
                  <q-card-section class="text-caption q-pa-xs text-bold">
                    Nro de solicitud
                  </q-card-section>
                  <q-card-section class="q-pa-xs">
                    {{move_pendiente.solicitud.numero}}
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-xs-6 text-white q-pl-xs">
                <q-card flat class="bg-grey-9">
                  <q-card-section class="text-caption q-pa-xs text-bold">
                    Monto ({{move_pendiente.solicitud.moneda.nombre}})
                  </q-card-section>
                  <q-card-section class="q-pa-xs">
                    {{util.numberMoney(move_pendiente.solicitud.total)}}
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-xs-12 text-white">
                <q-card flat class="bg-grey-9">
                  <q-card-section class="text-caption q-pa-xs text-bold">
                    Proyecto
                  </q-card-section>
                  <q-card-section class="q-pa-xs">
                    {{move_pendiente.solicitud.nom_completo_proyecto}}
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-xs-12 text-white text-center">
                <span>Mover a:</span>
              </div>
              <div class="col-xs-12 text-white">
                <div class="q-gutter-sm">
                  <q-radio dark v-model="move_pendiente.pendiente" val="pendiente" label="PENDIENTES 1" v-if="current_page != 'solicitudes-admin/pendientes1'"/>
                  <q-radio dark v-model="move_pendiente.pendiente" val="pendiente2" label="PENDIENTES 2" v-if="current_page != 'solicitudes-admin/pendientes2'"/>
                  <q-radio dark v-model="move_pendiente.pendiente" val="pendiente3" label="PENDIENTES 3" v-if="current_page != 'solicitudes-admin/pendientes3'"/>
                  <q-radio dark v-model="move_pendiente.pendiente" val="pendiente4" label="PENDIENTES 4" v-if="current_page != 'solicitudes-admin/pendientes4'"/>
                  <q-radio dark v-model="move_pendiente.pendiente" val="pendiente5" label="PENDIENTES 5" v-if="current_page != 'solicitudes-admin/pendientes5'"/>
                  <q-radio dark v-model="move_pendiente.pendiente" val="pendiente6" label="PENDIENTES 6" v-if="current_page != 'solicitudes-admin/pendientes6'"/>
                  <q-radio dark v-model="move_pendiente.pendiente" val="pendiente7" label="PENDIENTES 7" v-if="current_page != 'solicitudes-admin/pendientes7'"/>
                  <q-radio dark v-model="move_pendiente.pendiente" val="pendiente8" label="PENDIENTES 8" v-if="current_page != 'solicitudes-admin/pendientes8'"/>
                  <q-radio dark v-model="move_pendiente.pendiente" val="pendiente9" label="PENDIENTES 9" v-if="current_page != 'solicitudes-admin/pendientes9'"/>
                  <q-radio dark v-model="move_pendiente.pendiente" val="pendiente10" label="PENDIENTES 10" v-if="current_page != 'solicitudes-admin/pendientes10'"/>
                  <q-radio dark v-model="move_pendiente.pendiente" val="pendiente11" label="PENDIENTES 11" v-if="current_page != 'solicitudes-admin/pendientes11'"/>
                  <q-radio dark v-model="move_pendiente.pendiente" val="pendiente12" label="PENDIENTES 12" v-if="current_page != 'solicitudes-admin/pendientes12'"/>
                </div>
              </div>
            </div>
            
          </q-card-section>
          <q-card-actions>
            <div class="row full-width">
              <div class="col-xs-6 q-pa-sm">
                <q-btn
                  label="Cancelar"
                  color="negative"
                  icon="clear"
                  class="full-width"
                  @click="move_pendiente.dialog = false"
                ></q-btn>
              </div>
              <div class="col-xs-6 q-pa-sm">
                <q-btn
                  type="submit"
                  label="Mover"
                  color="positive"
                  icon="check"
                  class="full-width"
                  :loading="move_pendiente.loading"
                ></q-btn>
              </div>
            </div>
          </q-card-actions>
        </q-form>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { ref, inject } from 'vue'
import axios from 'axios'
import {useQuasar} from 'quasar'
import {useRouter} from 'vue-router'

import util from '../../plugins/util'
import moment from 'moment'

export default {
  name: 'Presidencia',
  setup () {
    const $q = useQuasar()
    const router = useRouter()

    // Variables reactivas y no reactivas
    const bus = inject('bus')

    const solicitudes = ref({
      data: []
    })
    const current_page = ref('solicitudes/admin')
    const bar_color = ref('1ABB9C')
    const next_page = ref(null)
    const infiniteScroll = ref(null)
    const loading = ref(false)
    const fabRight = ref(false)
    const created = ref(false)
    const section = ref({
      title: 'APROBAR SOLICITUDES'
    })

    const total_monedas = ref([])

    const express = ref({
      dialog: false,
      solicitud: null,
      loading: false
    })

    const move_pendiente = ref({
      dialog: false,
      solicitud: null,
      loading: false,
      pendiente: null
    })

    const search = ref(false)
    const search_params = ref({
      consulta: '',
      empresa_id: 0,
      gestion_id: 0,
      proyecto_id: 9999,
      selectMonto: 0,
      monto: '',
      fecha_ini:'',
      fecha_fin: '',
      campo: 0,
      chk_fr_cc: ''
    })

    const params_filter = ref('')

    // Variables filtro
    const fondos = ref('')
    const empresas = ref([
      {
        id: 0,
        nombre: 'TODAS LAS EMPRESAS'
      }
    ])
    const proyectos = ref([
      {
        id: 9999,
        nombre: 'NINGUNO'
      }
    ])
    const gestiones = ref([])
    const select_monto = ref([
      {
        id: 0,
        tipo: '='
      },
      {
        id: 1,
        tipo: '>'
      },
      {
        id: 2,
        tipo: '>='
      },
      {
        id: 3,
        tipo: '<'
      },
      {
        id: 4,
        tipo: '<='
      },
    ])
    const campos = [
      {
        id: 0,
        nombre: 'NINGUNO'
      },
      {
        id: 1,
        nombre: 'SOLICITANTE'
      },
      {
        id: 2,
        nombre: 'DESEMBOLSO'
      },
      {
        id: 3,
        nombre: 'REFERENCIA'
      },
      {
        id: 4,
        nombre: 'OBSERVACIÓN'
      },
      {
        id: 5,
        nombre: 'NÚMERO DE SOLICITUD'
      },
      {
        id: 6,
        nombre: 'TODOS'
      }
    ]

    const loading_filter = ref(false)
    const has_filter = ref(false)
    
    // Métodos y funciones
    const getSolicitudes = async (page) => {
      $q.loading.show()
      search_params.value.chk_fr_cc = ''
      total_monedas.value = []
      loading.value = true
      current_page.value = page
      let res = await axios.get(page)
      solicitudes.value = res.data.solicitudes.data
      for (let i = 1; i <= 4; i++) {
        let title = ''
        let color = '#ffffff'
        switch (i) {
          case 1:
            title = 'TOTAL (BS.)'
            color = '#FF1111'
            break
          case 2:
            title = 'TOTAL ($US.)'
            color = '#006600'
            break
          case 3:
            title = 'TOTAL (€)'
            color = '#0033cc'
            break
          case 4:
            title = 'TOTAL (S/)'
            color = '#9B59B6'
            break
        }
        let data = {
          title,
          amount: res.data.total_monedas[i],
          color
        }
        total_monedas.value.push(data)
      }
      next_page.value = res.data.solicitudes.next_page_url
      $q.loading.hide()
      params_filter.value = ''
      loading.value = false
    }

    const postSolicitudes = async (data) => {
      $q.loading.show()
      total_monedas.value = []
      loading.value = true
      let res = await axios.post(current_page.value, data)
      solicitudes.value = res.data.solicitudes.data
      params_filter.value = res.data.filtros
      for (let i = 1; i <= 4; i++) {
        let title = ''
        let color = '#ffffff'
        switch (i) {
          case 1:
            title = 'TOTAL (BS.)'
            color = '#FF1111'
            break
          case 2:
            title = 'TOTAL ($US.)'
            color = '#006600'
            break
          case 3:
            title = 'TOTAL (€)'
            color = '#0033cc'
            break
          case 4:
            title = 'TOTAL (S/)'
            color = '#9B59B6'
            break
        }
        let data = {
          title,
          amount: res.data.total_monedas[i],
          color
        }
        total_monedas.value.push(data)
      }
      next_page.value = res.data.solicitudes.next_page_url
      $q.loading.hide()
      loading.value = false
    }

    // Color del card según tiempo de solicitud
    const getColorCard = (fecha_created_at) => {
      let color = ''
      let dias_diff = moment().diff(moment(fecha_created_at, 'DD-MM-YYYY'), 'days')
      if (dias_diff <= 3) {
        color = 'bg-green-7'
      } else if (dias_diff > 3 && dias_diff <= 7) {
        color = 'bg-yellow-7 text-black'
      } else if (dias_diff > 7 && dias_diff <= 14) {
        color = 'bg-orange-7'
      } else if (dias_diff > 14) {
        color = 'bg-red-7'
      }
      return color
    }

    // Color de la moneda
    const getColorMoney = (moneda) => {
      switch (moneda.id) {
        case 1:
          return 'text-negative'
        case 2:
          return 'text-positive'
        case 3:
          return 'text-blue'
        case 4:
          return 'text-purple'
      }
    }

    const getEmpresas = async () => {
      try {
        let res = await axios.get('empresa')
        res.data.forEach(elem => {
          empresas.value.push(elem)
        })
      } catch (error) {
        console.log(error)
      }
    }

    const getProyectosEmpresa = async () => {
      try {
        let res = await axios.get(`json/proyectos/empresa/${search_params.value.empresa_id}`)
        if (res.data.length > 0) {
          proyectos.value = []
          proyectos.value.push({
            id: 0,
            nombre: 'TODOS LOS PROYECTOS'
          })
          search_params.value.proyecto_id = 0
          res.data.forEach(elem => {
            proyectos.value.push(elem)
          })
        }
      } catch (error) {
        console.log(error)
      }
    }

    const getGestiones = async () => {
      try {
        const data = {
          id: 0,
          gestion: 'TODAS'
        }
        gestiones.value.push(data)
        let res = await axios.get('gestion')
        res.data.forEach(elem => {
          gestiones.value.push(elem)
        })
        search_params.value.gestion_id = res.data[res.data.length -1].id

      } catch (error) {
        console.log(error)
      }
    }

    const filter = async () => {
      try {
        loading_filter.value = true
        let data = {
          ...search_params.value,
          fecha_ini: moment(search_params.value.fecha_ini, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          fecha_fin: moment(search_params.value.fecha_fin, 'DD/MM/YYYY').format('YYYY-MM-DD')
        }
        if (data.proyecto_id == 9999) {
          delete data.proyecto_id
        }
        if (data.fecha_ini == "Invalid date") {
          data.fecha_ini = ""
        }
        if (data.fecha_fin == "Invalid date") {
          data.fecha_fin = ""
        }
        if (data.chk_fr_cc == "") {
          delete data.chk_fr_cc
        }
        postSolicitudes(data)
        search.value = false
        loading_filter.value = false
      } catch (error) {
        console.log(error)
      }
    }

    

    const verDetalle = (id) => {
      const data = {
        id,
        current_page: current_page.value
      }
      bus.emit('openDialogDetalleSolicitudAutorizar', data)
    }

    const refresh = (done) => {
      getSolicitudes(current_page.value)
      if (infiniteScroll.value !== null) {
        infiniteScroll.value.resume()
      }
      done()
    }

    const onLoad = async (index, done) => {
      if (next_page.value) {
        let res = await axios({
          url: next_page.value,
          method: 'get'
        })
        let datos = res.data.solicitudes.data
        for (let clave in datos){
          solicitudes.value.push(datos[clave])
        }
        next_page.value = res.data.solicitudes.next_page_url
        done()
      } else {
        done(true)
      }
    }

    const onLeft = (solicitud, {reset}) => {
      express.value.solicitud = solicitud
      express.value.dialog = true
      reset()
    }

    const onRight = (solicitud, {reset}) => {
      move_pendiente.value.solicitud = solicitud
      move_pendiente.value.dialog = true
      reset()
    }

    const aprobarExpress = async () => {
      try {
        express.value.loading = true
        await axios.get(`solicitud-aprobacion-creada?id_sol=${express.value.solicitud.id}&obs=SO&platform=${util.getPlatform()}`)
        $q.notify({
          message: 'Solicitud Aprobada',
          color: 'positive'
        })
        express.value.loading = false
        express.value.dialog = false
        getSolicitudes(current_page.value)
        // filter()
      } catch (error) {
        console.log(error)
      }
    }

    const moverPendiente = async () => {
      try {
        if (move_pendiente.value.pendiente == null) {
          return $q.notify({
            message: 'Elija una opción por favor',
            color: 'negative'
          })
        }
        move_pendiente.value.loading = true

        await axios.get(`solicitudes-admin/cambio/${move_pendiente.value.pendiente}?pendiente=${move_pendiente.value.solicitud.id}&platform=${util.getPlatform()}`)
        $q.notify({
          message: 'Solicitud Pendiente Movida',
          color: 'positive'
        })
        move_pendiente.value.loading = false
        move_pendiente.value.pendiente = null
        move_pendiente.value.dialog = false
        // getSolicitudes(current_page.value)
        filter()
      } catch (error) {
        console.log(error)
      }
    }

    // Creación del componente
    getSolicitudes(current_page.value)
    bus.on('closeDialogCrearSolicitudAutorizar', () => {
      getSolicitudes(current_page.value)
    })
    bus.on('changePage', (data) => {
      solicitudes.value = []
      getSolicitudes(data.link)
      bar_color.value = data.color
      section.value = data
    })

    getEmpresas()
    getGestiones()

    return {
      solicitudes,
      router,
      verDetalle,
      refresh,
      onLoad,
      bar_color,
      current_page,
      util,
      infiniteScroll,
      loading,
      getColorCard,
      getColorMoney,
      fabRight,
      created,
      section,
      total_monedas,
      onLeft,
      onRight,
      express,
      aprobarExpress,
      search,
      fondos,
      search_params,
      empresas,
      getProyectosEmpresa,
      proyectos,
      gestiones,
      select_monto,
      filter,
      campos,
      loading_filter,
      postSolicitudes,
      move_pendiente,
      moverPendiente,
      params_filter,
      has_filter
    }

  }
}
</script>

<style>

</style>